'use client';

import s from 'Workadabra/app/[lang]/home/sections/earn/styles.module.css';
import { rdEarnBody, rdEarnBullet1, rdEarnBullet2, rdEarnBullet3, rdEarnBullet4, rdEarnCardJobs, rdEarnCardLabel, rdEarnCardSpeed, rdEarnCardSpeedValue, rdEarnCta, rdEarnPaint, rdEarnPre } from 'Workadabra/translations';
import { getLanguageFromLocale } from '@bomdisoft/translations';
import { useParams } from 'next/navigation';

const APP_URL = process.env.NEXT_PUBLIC_APP_URL ?? '#';

export const EarnSection = () => {
  const params = useParams();
  const language = getLanguageFromLocale(params?.lang as string);

  const bullets = [rdEarnBullet1, rdEarnBullet2, rdEarnBullet3, rdEarnBullet4];

  return (
    <section className={s.root} data-testid='earn-section' id='earn'>
      <div className={s.band}>
        <div>
          <h2 className={s.heading}>
            {rdEarnPre[language]} <span className={s.highlight}>{rdEarnPaint[language]}</span>
          </h2>
          <p className={s.body}>{rdEarnBody[language]}</p>
          <ul className={s.list}>
            {bullets.map(bullet => (
              <li className={s.item} key={bullet.english}>
                <span className={s.check}>✓</span>
                {bullet[language]}
              </li>
            ))}
          </ul>
          <a className={s.cta} data-testid='earn-cta' href={APP_URL}>
            {rdEarnCta[language]}
          </a>
        </div>
        <div className={s.payout}>
          <p className={s.payoutLabel}>{rdEarnCardLabel[language]}</p>
          <p className={s.payoutBig}>{`£ 642.00`}</p>
          <div className={s.payoutRow}>
            <span>{rdEarnCardJobs[language]}</span>
            <span className={s.payoutVal}>7</span>
          </div>
          <div className={s.payoutRow}>
            <span>{rdEarnCardSpeed[language]}</span>
            <span className={s.payoutValHighlight}>{rdEarnCardSpeedValue[language]}</span>
          </div>
        </div>
      </div>
    </section>
  );
};
